import { BadgeProductCategoryModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class BadgeProductCategoryService extends ApiService<BadgeProductCategoryModel> {
	constructor() {
		super('badgeproductcategory');
	}
}

export default new BadgeProductCategoryService();
